import type { AccessibilitySettings } from './types'

type DetectedPreferences = Partial<Pick<AccessibilitySettings, 'reducedMotion' | 'contrastMode'>>

export function detectPreferredSettings(): DetectedPreferences | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return null
  }

  const detected: DetectedPreferences = {}

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    detected.reducedMotion = true
  }

  if (window.matchMedia('(prefers-contrast: more)').matches) {
    detected.contrastMode = 'high'
  }

  return Object.keys(detected).length > 0 ? detected : null
}
